
import {PropType} from "vue";
import {InternetDiscountPopinDto} from "../../cart/models/InternetDiscountPopinDto";
import TextField from "../ob1/TextField.vue";
import Lien from "../ob1/Lien.vue";
import AlertMessage from "../ob1/AlertMessage.vue";

export default {
    name: "DiscountPopinFormShared",
    components: {
        TextField,
        Lien,
        AlertMessage
    },
    props: {
        activeView: {
            type: String,
            required: true
        },
        dto: {
            type: Object as PropType<InternetDiscountPopinDto>,
            required: true
        },
        phoneLineValue: {
            type: String,
            required: true
        },
        phoneLineErrorMessage: {
            type: String,
            required: true
        },
        customerCodeValue: {
            type: String,
            required: true
        },
        customerCodeErrorMessage: {
            type: String,
            required: true
        },
        showAlertMessage: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        onPhoneLineChange(value: string) {
            const filteredValue = value.replace(/\\D/g, '');
            this.$emit("update:phoneLineValue", filteredValue);
            this.$emit("update:showAlertMessage", false);
            this.$emit("update:phoneLineErrorMessage", "");
            this.$emit("update:customerCodeErrorMessage", "");
        },
        onCustomerPidChange(value: string) {
            const filteredValue = value.replace(/\\D/g, '');
            this.$emit("update:customerCodeValue", filteredValue);
            this.$emit("update:showAlertMessage", false);
            this.$emit("update:phoneLineErrorMessage", "");
            this.$emit("update:customerCodeErrorMessage", "");
        },
        showInfo(event: Event) {
            if (event) {
                event.preventDefault();
            }
            this.$emit("update:activeView", "info");
        }
    }
}
